import { Outlet, Route } from '@tanstack/router'

import { rootRoute } from '../root'

export const promotionsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'promotions',
  component: Outlet,
})
